import { dashboardConstant } from "../../../../premium/constants/dashboardConstants";
import { LocalStorageService } from "../../../../services";
import authHeader from "../../../../services/auth/auth-header";
import { putApi, getApi } from "../../../../services/helpers/apiCall";


const loadCampaigns = () => (dispatch) => {
  dispatch(request());
  let userData = LocalStorageService.getObject("client");
  let apiCallRequest = {
    url: `/clients/byuserid/` + userData.userId,
    data: {},
    config: {
      headers: authHeader(),
    },
  };
  getApi(apiCallRequest)
    .then((response) => {
      let client = response.data;
      const apiCallRequestClient = {
        url: `/gcp/getCampaign/` + client.companyId,
        data: {},
        config: {
          headers: authHeader(),
        },
      };
      getApi(apiCallRequestClient)
        .then((response) => {
          let campaigns = response.data.campaigns;
          dispatch(success(campaigns));
        })
        .catch((err) => {
          dispatch(failure(err.response.data.msg));
        });
    })
    .catch((err) => {
      dispatch(failure(err.response.data.msg));
    });

  function request() {
    return {
      type: dashboardConstant.LOAD_CAMPAIGNS_START,
      payload: {
        loading: true,
      },
    };
  }

  function success(campaigns) {
    return {
      type: dashboardConstant.LOAD_CAMPAIGNS,
      payload: {
        loading: false,
        campaigns,
      },
    };
  }
  function failure(error) {
    return {
      type: dashboardConstant.LOAD_CAMPAIGNS_ERROR,
      payload: {
        loading: false,
        error,
      },
    };
  }
};

const updateCampaignDate = (data) => (dispatch) => {
  dispatch(request(true));
  let apiCallRequest = {
    url: "/campaigns/" + data.id,
    data: {
      start_date: data.launchDate,
      end_date: data.closingDate,
      state: data.state,
    },
    config: {
      headers: authHeader(),
    },
  };
  putApi(apiCallRequest)
    .then((response) => {
      let userData = LocalStorageService.getObject("client");
      let apiCallRequest = {
        url: `/clients/byuserid/` + userData.userId,
        data: {},
        config: {
          headers: authHeader(),
        },
      };
      getApi(apiCallRequest)
        .then((response) => {
          let client = response.data;
          const apiCallRequestClient = {
            url: `/gcp/getCampaign/` + client.companyId,
            data: {},
            config: {
              headers: authHeader(),
            },
          };
          getApi(apiCallRequestClient)
            .then((response) => {
              let campaigns = response.data.campaigns;
              dispatch(success(campaigns));
            })
            .catch((err) => {
              dispatch(failure(err.message));
            });
        })
        .catch((err) => {
          dispatch(failure(err.response.data.msg));
        });
    })
    .catch((err) => {
      dispatch(failure(err.response.data.msg));
    });

  function request(loading) {
    return { type: dashboardConstant.UPDATE_CAMPAIGN_REQUEST, loading: true };
  }

  function success(campaigns) {
    return {
      type: dashboardConstant.UPDATE_CAMPAIGN_DATE,
      payload: {
        loading: false,
        campaigns,
      },
    };
  }
  function failure(error) {
    return {
      type: dashboardConstant.UPDATE_CAMPAIGN_DATE_FAIL,
      payload: {
        loading: false,
        error,
      },
    };
  }
};

export { updateCampaignDate, loadCampaigns };
